/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { FC } from 'react';
import { Box, Stack, Typography } from '@mui/material';

import AppVersion from '../AppVersion/AppVersion';
import UserAgreements from '../UserAgreements/UserAgreements';
import { MarginStyledBox } from '../../../../styled/box';
import FeatureLinks, { IFeatureLinksProps } from '../FeatureLinks/FeatureLinks';
import ContactProfileHeader from '../ContactProfileHeader/ContactProfileHeader';
import SelectedAccount, { ISelectedAccountProps } from '../SelectedAccount/SelectedAccount';
import TestIds from '../../../../testIds';

import './AccountMenu.scss';

export interface IAccountMenuProps extends ISelectedAccountProps, IFeatureLinksProps {
  style?: React.CSSProperties;
}

const AccountMenu: FC<IAccountMenuProps> = ({
  enableAccountSwitcher,
  enableAccountDetails,
  enableQuotes,
  enableAgreements,
  enableDeclarations,
  enableActivities,
  enableOrders,
  enableLogout,
  divider,
  style,
}: IAccountMenuProps): JSX.Element => (
  <Box
    className='fl-account-menu fl-word-break'
    data-testid={TestIds.feat.account.userAccount.accountMenu.component}
    sx={style}
  >
    <ContactProfileHeader />

    <MarginStyledBox>
      <SelectedAccount enableAccountSwitcher={enableAccountSwitcher} fullScreenModal />

      <FeatureLinks
        enableAccountDetails={enableAccountDetails}
        enableQuotes={enableQuotes}
        enableAgreements={enableAgreements}
        enableDeclarations={enableDeclarations}
        enableActivities={enableActivities}
        enableOrders={enableOrders}
        enableLogout={enableLogout}
        divider={divider}
      />

      <MarginStyledBox>
        <Stack spacing='1rem' alignItems='start' marginTop='1.25rem' marginBottom='2.5rem'>
          <UserAgreements />

          <AppVersion />

          <Typography variant='defaultSmall' component='p'>
            Copyright &copy; Farmlands Co-operative Society Limited {new Date().getFullYear()} | All
            rights reserved.
          </Typography>
        </Stack>
      </MarginStyledBox>
    </MarginStyledBox>
  </Box>
);

export default AccountMenu;
